import React from "react";
import PencilIcon from "mdi-react/PencilIcon";

export default ({ open }) => (
  <div className="roundedButton">
    <PencilIcon color="#5F39DE" onClick={open} />
  </div>
);
